import { getReplacementMotives } from '@/backend/replacementMotives'

const SET_REPLACEMENT_MOTIVES = 'SET_REPLACEMENT_MOTIVES';

const state = {
  replacementMotives: []
}

export const mutations = {
  [SET_REPLACEMENT_MOTIVES] (state, replacement_motives) {
    state.replacementMotives = replacement_motives
  }
}

export const actions = {
  initReplacementMotives({commit}) {
    return getReplacementMotives()
      .then((response) => {
        commit(SET_REPLACEMENT_MOTIVES, response.data)
      })
  }
}

export const getters = {
  replacementMotives: state => state.replacementMotives
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/replacementMotives.js